import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-28" data-id="element-136" data-mp="1qalq4w8vplqd">
      <div className="mx-auto flex max-w-4xl flex-col items-center gap-10 text-center sm:flex-row sm:gap-14 sm:text-right" data-id="element-137" data-mp="1o2lq4y82a9za">
        <svg viewBox="0 0 200 200" className="h-40 w-40 shrink-0 -rotate-6 text-red-700 sm:h-44 sm:w-44" role="img" aria-label="ضمان رضا ٧ أيام" data-id="element-138" data-mp="222wkib8ky6p7">
          <defs data-id="element-139" data-mp="19ehege7feyq0">
            <path id="guarantee-stamp-path" d="M100,100 m-80,0 a80,80 0 1,1 160,0 a80,80 0 1,1 -160,0" data-id="element-140" data-mp="19dzdj49tjwbr" />
          </defs>
          <circle cx="100" cy="100" r="95" fill="none" stroke="currentColor" strokeWidth="3" data-id="element-141" data-mp="14gz2eey443ds" />
          <circle cx="100" cy="100" r="64" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-142" data-mp="1j5c4zurpgkh9" />
          <text fill="currentColor" fontSize="14" fontWeight="700" letterSpacing="2" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-143" data-mp="1ed25bn0sg61s">
            <textPath href="#guarantee-stamp-path" textLength="498" lengthAdjust="spacing" data-id="element-144" data-mp="qm6kxaynwd4k">
              ضمان الرضا · اشترِ بثقة · ضمان الرضا · اشترِ بثقة ·
            </textPath>
          </text>
          <text x="100" y="112" textAnchor="middle" fill="currentColor" fontSize="64" fontFamily="ui-serif, Georgia, serif" data-id="element-145" data-mp="oxf9y8phgns1">
            ٧
          </text>
          <text x="100" y="136" textAnchor="middle" fill="currentColor" fontSize="13" fontWeight="700" letterSpacing="3" fontFamily="ui-sans-serif, system-ui, sans-serif" data-id="element-146" data-mp="yqe0hw4jioea">
            أيام
          </text>
        </svg>

        <div data-id="element-147" data-mp="628fd89kqxdx">
          <h2 className="font-serif text-4xl leading-tight tracking-tight text-slate-900 sm:text-5xl" data-id="element-148" data-mp="62qj0pykgdvv">
            ضمان رضا ٧ أيام
          </h2>
          <p className="mt-5 max-w-xl text-lg leading-relaxed text-slate-900/75" data-id="element-149" data-mp="f0u1fde98ujg">
            نزّل المواد وجرّبها في دروسك. إذا لم تلبِّ الحقيبة توقعاتك، راسلنا بالبريد الإلكتروني واطلب استرداد المبلغ خلال ٧ أيام من الشراء، وفق شروط الضمان.
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-900/60" data-id="element-150" data-mp="1qile0nor1kog">
            لا يؤثر هذا الضمان على حقوقك وفق أنظمة حماية المستهلك المعمول بها.
          </p>
        </div>
      </div>
    </section>;
}